import { Post } from '../helpers';

const AttachGreenroomMask = async (
  meetingId: number,
  maskId: number,
  email: string,
  token: string
): Promise<string> => {
  return Post({
    host: import.meta.env.VITE_GREENROOM_APP_SYNC_HOST,
    url: `/v1/room/${meetingId}/profile-masks/mutate`,
    body: {
      maskId: maskId,
      email: email,
      detach: false,
    },
    headers: {
      'id-token': token,
      'bl-global-resource': 'false',
    },
  });
};

export default AttachGreenroomMask;
